const VIDEO_CARD_GOALS = {
  play: 'videoCardDoctor__play', // Видеовизитки, Страница врача - Запустили просмотр видео
  finish: 'videoCardDoctor__finish', // Видеовизитки, Страница врача - Досмотрели видео до конца
  closeWithoutView: 'videoCardDoctor__closeWithoutView', // Видеовизитки, Страница врача - Закрыли модалку с видео, не досмотрев видео
}

export default VIDEO_CARD_GOALS
